import AOS from 'aos';
import { FlexGallery } from './FlexGallery';
import { InfiniteScrolling } from './InfiniteScrolling';
import { Navbar } from './Navbar';
import { Slider } from './Slider';
import { Tags } from './Tags';

import '@fortawesome/fontawesome-free/js/all';
import 'aos/dist/aos.css';
import 'fslightbox';
import '../styles/index.scss';

const init = async (): Promise<void> => {
    const navbar = new Navbar();

    navbar.register();

    const slider = new Slider();

    slider.startRotation();

    const tags = new Tags();

    tags.removePostsIfThereAreTags();
    tags.initAosDelays();

    const flexGallery = new FlexGallery();

    await flexGallery.refresh();
    flexGallery.onUpdate = async (): Promise<void> => {
        /* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/ban-ts-ignore, no-undef */
        // @ts-ignore
        refreshFsLightbox();
        /* eslint-enable @typescript-eslint/ban-ts-comment, @typescript-eslint/ban-ts-ignore, no-undef */
    };

    const infiniteScrolling = new InfiniteScrolling();

    infiniteScrolling.register();
    infiniteScrolling.onUpdate = async (): Promise<void> => {
        await flexGallery.refresh();

        /* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/ban-ts-ignore, no-undef */
        // @ts-ignore
        refreshFsLightbox();
        /* eslint-enable @typescript-eslint/ban-ts-comment, @typescript-eslint/ban-ts-ignore, no-undef */
    };

    AOS.init();
};

init().catch((error): void => {
    throw error;
});
